import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between flex-wrap p-6 bg-white dark:bg-gray-900 fixed w-full shadow-md" }
const _hoisted_2 = { class: "flex items-center justify-between flex-nowrap flex-1" }
const _hoisted_3 = { class: "flex items-center flex-no-shrink mr-6" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Inicio")
const _hoisted_5 = { class: "ml-4 block sm:hidden" }
const _hoisted_6 = { class: "text-sm sm:flex-grow ml:flex ml:flex-1 ml:flex-nowrap ml:flex-row ml:justify-around ml:items-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Acerca de")
const _hoisted_8 = {
  key: 0,
  class: "pt-32"
}
const _hoisted_9 = { class: "text-center pt-3 pb-9 text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl" }
const _hoisted_10 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "flex flex-row flex-nowrap w-full items-center justify-around py-8" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Anterior ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Siguiente ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_search_bar = _resolveComponent("search-bar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_button_router_link = _resolveComponent("button-router-link")!
  const _component_absolute_loader = _resolveComponent("absolute-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "hover:text-blue-900 dark:hover:text-indigo-600",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createElementVNode("form", {
            role: "search",
            class: "w-full h-12",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSearchSubmit && _ctx.onSearchSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_search_bar, {
              value: _ctx.searchQuery,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
              placeholder: 'Busca un GIF de perritos 🐶'
            }, null, 8, ["value"])
          ], 32),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
              class: "flex items-center justify-center px-3 py-2 rounded text-teal-lighter border-teal-light hover:text-blue-900 dark:hover:text-indigo-600 h-5 w-5"
            }, [
              (!_ctx.open)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    title: "Abrir menú",
                    icon: ['fas', 'bars'],
                    class: "fill-current"
                  }))
                : (_ctx.open)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      title: "Cerrar menú",
                      icon: ['fas', 'times'],
                      class: "fill-current"
                    }))
                  : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.open ? 'block': 'hidden', "w-full sm:flex sm:items-center sm:w-auto"])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "sm:ml-6 no-underline block mt-4 sm:inline-block sm:mt-0 hover:text-blue-900 dark:hover:text-indigo-600",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ], 2)
      ])
    ]),
    _createElementVNode("main", null, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.totalResults) + " " + _toDisplayString(_ctx.singleResult) + " para la búsqueda: ", 1),
              _createElementVNode("strong", null, [
                _createElementVNode("em", null, "perritos " + _toDisplayString(decodeURIComponent(_ctx.$route.query.q)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gifData.data, (gif) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "rounded-lg max-w-sm mx-auto bg-white shadow-md space-y-2 sm:flex sm:items-center sm:space-y-0 sm:space-x-6",
                  style: _normalizeStyle({ height: `${gif.images.fixed_height.height}px`, width: `${gif.images.fixed_height.width}px` }),
                  key: gif.id
                }, [
                  _createElementVNode("img", {
                    class: "block mx-auto sm:flex-shrink-0 rounded-lg",
                    src: gif.images.fixed_height.url,
                    alt: gif.title
                  }, null, 8, _hoisted_11)
                ], 4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              (!_ctx.shouldPrevPageBeDisabled)
                ? (_openBlock(), _createBlock(_component_button_router_link, {
                    key: 0,
                    class: "text-center mx-4",
                    to: _ctx.prevPage
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              (!_ctx.shouldNextPageBeDisabled)
                ? (_openBlock(), _createBlock(_component_button_router_link, {
                    key: 1,
                    class: "text-center mx-4",
                    to: _ctx.nextPage
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_absolute_loader, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}